<template>
  <div
    class="tabs-container ng-scope"
    style="padding-bottom: 50px; margin-top: 18px"
  >
    <el-form
      :model="user"
      ref="user"
      label-width="0px"
      class="demo-dynamic form-horizontal detailPage"
    >
      <div class="tab-content">
        <div>
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{ $t("message.userName") }}
                  <span style="color: red">*</span>
                </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="userName"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input
                      v-model="user.userName"
                      :name="'userName'"
                      maxLength="30"
                    />
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{ $t("message.password") }}
                  <span style="color: red" v-if="!$route.query.id">*</span>
                </label>
                <div class="col-sm-10">
                  <el-form-item
                    prop="password"
                    :rules="[
                      {
                        required: $route.query.id ? false : true,
                        message: $t('message.required'),
                        trigger: 'blur',
                      },
                      {
                        pattern: /^[A-Za-z0-9]{8,15}$/,
                        message:
                          'Please enter a password in the correct format',
                      },
                    ]"
                  >
                    <el-input
                      type="password"
                      v-model="user.password"
                      :name="'password'"
                    />
                    <div class="passwordFormat">
                      {{ $t("message.passwordFormat") }}
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{ $t("message.email") }}
                </label>
                <div class="col-sm-10">
                  <div>
                    <el-input
                      type="email"
                      v-model="user.email"
                      :name="'email'"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{ $t("message.RoleName") }}
                  <span style="color: red">*</span>
                </label>
                <div class="col-sm-3">
                  <el-form-item
                    prop="roleId"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'change',
                    }"
                  >
                    <el-select clearable v-model="user.roleId" name="role">
                      <el-option
                        :label="role.roleName"
                        :value="role.id"
                        class="ng-binding"
                        v-for="role in roleList"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{ $t("message.Status") }}
                  <span style="color: red">*</span>
                </label>
                <div class="col-sm-3">
                  <el-form-item
                    prop="status"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'change',
                    }"
                  >
                    <el-select clearable v-model="user.status" name="status">
                      <el-option
                        v-for="item in statusObj"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>

              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div
                      class="btn btn-primary"
                      v-if="
                        (!$route.query.id &&
                          checkPermission('USER_LIST_NEW')) ||
                        ($route.query.id && checkPermission('USER_LIST_UPDATE'))||
                        $store.state.userInfo.systemUserId == user.id
                      "
                      @click="checkEvent()"
                    >
                      {{ $t("message.Save") }}
                    </div>
                    <div class="btn btn-white" @click="showWarning()">
                      {{ $t("message.Cancel") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      user: {},
      roleList: [],
      statusObj: [],
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    async init() {
      let id = this.$route.query.id;
      if (id) {
        let obj = this.getAuthObj();
        obj.systemUserId = id;
        obj.apiUrl = "/getSystemUserDetail";
        var data = await this.$store.dispatch("apiEvent", obj);
        if (!data) return;
        data.data.result.status += "";
        data.data.result.updUserId = data.data.result.id;
        data.data.result.roleId = data.data.result.systemRoleId;
        this.$set(this, "user", data.data.result);
      } else {
        let initUser = {
          id: null,
          password: "",
          userName: "",
          email: "",
          mobile: "",
          status: "",
          roleId: "",
        };
        this.$set(this, "user", initUser);
      }
      this.statusObj = [
        {
          value: "1",
          label: this.$i18n.t("message.Active"),
        },
        {
          value: "0",
          label: this.$i18n.t("message.Inactive"),
        },
      ];
      this.getRoleList();
    },
    goBack() {
      this.$router.push({
        path: "/main/userList",
        query: { ...this.$route.query }
      });
    },
    async getRoleList() {
      let obj = this.getAuthObj();
      obj.apiUrl = "/getSystemRoleAllList";
      var data = await this.$store.dispatch("apiEvent", obj);
      if (!data) return;
      this.$set(this, "roleList", data.data.result);
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        this.goBack();
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function () {
                that.callDelete();
              },
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function () {},
            },
          ],
        });
      }
    },
    checkEvent: function () {
      this.$refs["user"].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    async submit() {
      try {
        let obj = this.getAuthObj();
        for (var key in this.user) {
          obj[key] = this.user[key];
        }

        if (this.$route.query.id) {
          obj.apiUrl = "/updateSystemUser";
          var data = await this.$store.dispatch("apiEvent", obj);
        } else {
          obj.apiUrl = "/createSystemUser";
          var data = await this.$store.dispatch("apiEvent", obj);
        }
        if (!data) return;
        if (data.data.errorCode === 0) {
          this.goBack();
        }
      } catch (err) {}
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {
      try {
        let obj = this.getAuthObj();
        obj.ids = [this.$route.query.id];
        obj.apiUrl = "/delSystemUser";
        var data = await this.$store.dispatch("apiEvent", obj);
        if (!data) return;
        if (data.data.errorCode === 0) {
          this.goBack();
        }
      } catch (err) {}
    },
  },
};
</script>
